
import DefaultLayout from '@/layouts/Default.vue'
import Toast from '@/components/Toast.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    Toast
  },
  setup () {
    const layoutComponent = DefaultLayout

    return {
      layoutComponent
    }
  }
})
